<!-- navItem „Gruppen“ — period history of the agent's provision type assignment. -->
<div class="cp-provision-agent-groups">

    @if (!initialized) {
        <p-skeleton height="16rem"></p-skeleton>
    } @else if (!provisionAgentId) {
        <p-message severity="info" text="Kein Abrechnungskonto ausgewählt." styleClass="w-full"></p-message>
    } @else if (groupsWidget) {
        <mvs-widget #groupsWidgetRef [widgetData]="groupsWidget"></mvs-widget>
    }

</div>
